import api from "dao/providers/axios";
import appconfig from "config/appconfig";

const oAuthPermissionsEndPoint = appconfig.endpoints.oAuthPermissions;

export const daoOAuthPermissionsGet = (clientId) => api.get(oAuthPermissionsEndPoint(clientId));
